import React, { Fragment, useEffect } from "react";
import { connect } from "react-redux";

// Helpers
import NotAuthorized from "modules/5_view_helpers/mobile/NotAuthorized";
import HasRole from "modules/5_view_helpers/HasRole";

// Actions
import { getApprovals } from "../actions";
import { AccordionContent, Block, BlockTitle, Button, List, ListButton, ListItem, Page } from "framework7-react";
import AppNavbar from "modules/1_layout/mobile/AppNavbar";
import ApprovalStepButton from "../steps/ApprovalStepButton";

function mapStateToProps(state) {
  return {
    current_user: state.current_user,
    approvals: state.approvals,
  };
}

const ApprovalsIndex = (props) => {
  useEffect(() => {
    props.getApprovals();
  }, []);

  const { approvals, current_user } = props;
  const readRole = HasRole({ resource_type: "Approval", name: ["read", "moderator"] }, true);

  const unapprovedApprovals = _.filter(approvals, (approval) => !approval.approved);
  const approvedApprovals = _.filter(approvals, (approval) => approval.approved);

  if (!readRole) {
    return <NotAuthorized />;
  } else {
    return (
      <Page>
        <AppNavbar title={`${current_user?.name} - Approvals Required`} />
        {_.isNotEmpty(unapprovedApprovals) && <ApprovalsTable approvals={unapprovedApprovals} title="Unapproved Approvals" />}
        {!_.isNotEmpty(unapprovedApprovals) && <BlockTitle>No Unapproved Approvals</BlockTitle>}
      </Page>
    );
  }
};
export default connect(mapStateToProps, { getApprovals })(ApprovalsIndex);

const ApprovalsTable = ({ approvals, title }) => {
  return (
    <Block>
      <BlockTitle>{title}</BlockTitle>
      <List accordionList>
        {_.map(approvals, (approval) => (
          <ListItem
            accordionItem
            title={`${approval.title} - ${approval.approved ? "Approved" : "Unapproved"}`}
            style={{ border: "1px solid #000", marginBottom: "5px", padding: "5px" }}
          >
            <AccordionContent>
              <BlockTitle>Content</BlockTitle>
              <Block>
                {approval.content}

                {approval.report_link && (
                  <Fragment>
                    <hr />
                    <Button fill external target="_blank" href={approval.report_link}>
                      View Report
                    </Button>
                  </Fragment>
                )}
              </Block>

              <hr />

              <ApprovalSteps approval={approval} />
            </AccordionContent>
          </ListItem>
        ))}
      </List>
    </Block>
  );
};

const ApprovalSteps = ({ approval }) => {
  return (
    <Fragment>
      <List inset>
        {_.map(approval.steps, (step) => (
          <Fragment key={step.id}>
            <ListItem key={step.id}>
              Step {step.step_number} - {step.approver}
            </ListItem>
            <ApprovalStepButton mobile approval={approval} approval_step={step} approval_step_id={step.id} />
          </Fragment>
        ))}
      </List>
    </Fragment>
  );
};
